import DOMPurify from "dompurify"

export const Sanitize = html => {
  return DOMPurify.sanitize(html)
}
